import {Component, OnDestroy, OnInit} from '@angular/core';
import {RegistrationsService} from "../../services/registrations.service";
import {environment} from "../../../../environments/environment";
import {ActivatedRoute} from "@angular/router";
import {Subject, takeUntil} from "rxjs";
import {CoreService} from "../../services/core.service";

@Component({
  selector: 'app-generate-tokens',
  templateUrl: './generate-tokens.component.html',
  styleUrls: ['./generate-tokens.component.sass']
})
export class GenerateTokensComponent implements OnInit, OnDestroy{

  public FirstName: string = '';
  public LastName: string = '';
  public Email: string = '';
  public Salutation: string = 'Herr';
  public PhoneNumber: string = '676843020200';
  public PhoneNumberPrefix: string = '+43';
  public Zip: number = 3003;
  public Location: string = 'Gablitz';

  public projectShortName: string = '';


  public LegacyTokenIdentifierStep1: string | null | undefined = '';
  public LegacyTokenIdentifierStep2: string | null | undefined = '';

  private ngUnsubscribe = new Subject();


  constructor(
    private registrationService: RegistrationsService,
    private activatedRoute: ActivatedRoute,
    private coreService: CoreService
  ) {}

  ngOnInit() {
    if(!environment.production) {
      this.FirstName = this.generateString(8);
      this.LastName = this.generateString(8);
      this.Email = this.generateString(7) + '@' + this.generateString(5) + '.com';

      this.projectShortName = this.activatedRoute.snapshot.params['projectShortname'];

      this.postStep1Data();
    }
  }

  generateString(length: number) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  postStep1Data() {
    this.registrationService.registerCustomer(
      {
        FirstName: this.FirstName,
        LastName: this.LastName,
        Email: this.Email,
        Salutation: this.Salutation,
        PhoneNumber: this.PhoneNumber,
        PhoneNumberPrefix: this.PhoneNumberPrefix,
        CorrespondanceLanguageISOCode: "de"
      },
      this.projectShortName,
      "de"
    ).pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe((val) => {
      console.log(val);
      this.LegacyTokenIdentifierStep2 = val.tokenIdentifier;
    });

    this.coreService.disableGlobalLoading();
  }

  copyMessage(val: string | null | undefined){
    if(val) {
      const selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = val;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
    }
  }


  ngOnDestroy() {
    this.ngUnsubscribe.next('');
    this.ngUnsubscribe.complete();
  }
}
